import PurchaseReceiptController from 'controller/purchasereceiptcontroller.js';

// initial state
const state = {
  current: {}
};

// getters
const getters = {};

// actions
const actions = {
  getPurchaseReceipt (context, autoid) {
    let controller = new PurchaseReceiptController();
    controller.linkApiController(context.rootGetters.api);
    controller.GetByAutoID(autoid).then(result => {
      context.commit('setReceipt', result);
    }).catch(err => console.error(err));
  },
  refreshPurchaseReceipt (context) {
    if (context.state.current.AutoID) {
      context.dispatch('getPurchaseReceipt', context.state.current.AutoID);
    }
  }
};

// mutations
const mutations = {
  setReceipt (state, receipt) {
    state.current = receipt;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
